import React, { useContext, useState } from 'react'
import { CModal, CModalBody, CRow } from '@coreui/react'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import TemplatePreviewModal from './templatePreviewModal'
import { isEmpty } from 'lodash'
import CloseIcon from '../../../assets/editor-close-icon.svg'
import CustomImage from 'src/components/customImage/customImage'
import { AppContext } from 'src/views/context/app'

const WebsiteTemplateModal = ({ baseTemplateData, onstart, onClose }) => {
  const { accountObj } = useContext(AppContext)
  const [previewData, setPreviewData] = useState({})

  const premiumTemplate = (templateId) => {
    return !isEmpty(accountObj?.allowed_templates)
      ? !accountObj?.allowed_templates.includes(templateId)
      : true
  }

  const handleStart = (info) => {
    setPreviewData({})
    onstart(info)
  }
  return (
    <>
      <CModal size="xl" className="website-template-modal" visible={true}>
        <CModalBody style={{ padding: '2rem 0rem' }} className="">
          <div className="d-flex flex-row justify-content-between">
            <div style={{ padding: '0rem 9%' }}>
              <h4 style={{ marginTop: '2px' }}>Create your Website Template</h4>
              <p style={{ fontSize: '15px', color: '#707070' }}>
                Start making your website by selecting one of the templates given below.
              </p>
            </div>
            <div>
              <img
                src={CloseIcon}
                alt="CloseIcon"
                className="mx-4 cursor-pointer"
                onClick={onClose}
              />
            </div>
          </div>
          <div className="static-scrollbar-class" style={{ maxHeight: '77vh', padding: '0rem 5%' }}>
            <CRow className="" xs={{ cols: 2, gutterY: 5, gutterX: 0 }} classNam="">
              {!isEmpty(baseTemplateData) &&
                baseTemplateData.map((info, idx) => {
                  const isPremiumTemplate = premiumTemplate(info?._id)
                  return (
                    <div
                      className="text-center d-flex justify-content-center align-content-center"
                      key={idx}
                    >
                      <div>
                        <div className="template-img-container ">
                          <CustomImage
                            imageUrl={info?.preview_s3_key?.website}
                            imgClass="template-img"
                            loaderClass="w-100 h-100"
                            loaderStyle={{ background: '#5A5A5A50' }}
                            imgAlt={'thumbnail'}
                            errorPlaceholder={ImageNotFound}
                          />
                          <div className="template-img-text">
                            <div style={{ top: '37%' }} className="text-white position-absolute">
                              <p
                                style={{ fontSize: '1.3vw', fontWeight: '500', cursor: 'pointer' }}
                                onClick={() => onstart(info)}
                              >
                                Start with {`${info.template_name}`}
                              </p>
                              <hr style={{ color: 'white', fontSize: '2rem' }} className="w-100" />
                              <p
                                style={{ fontSize: '1.05vw', fontWeight: '500', cursor: 'pointer' }}
                                onClick={() => setPreviewData(info)}
                              >
                                PREVIEW {`${info.template_name}`}
                              </p>
                            </div>
                            {isPremiumTemplate && (
                              <div
                                style={{
                                  bottom: '23%',
                                  borderTop: '1px solid white',
                                  borderBottom: '1px solid white',
                                }}
                                className="text-white position-absolute"
                              >
                                <p
                                  style={{ fontSize: '1.05vw', fontWeight: '550' }}
                                  className="mb-0"
                                >
                                  PREMIUM TEMPLATE
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                        <p
                          style={{ fontSize: '1.5vw', fontWeight: '500' }}
                        >{`${info.template_name}`}</p>
                      </div>
                    </div>
                  )
                })}
            </CRow>
          </div>
        </CModalBody>
      </CModal>
      {!isEmpty(previewData) && (
        <TemplatePreviewModal
          previewData={previewData}
          onBack={() => setPreviewData({})}
          onStart={handleStart}
        />
      )}
    </>
  )
}

export default WebsiteTemplateModal
